import script from "./RingingCallBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./RingingCallBanner.vue?vue&type=script&setup=true&lang=ts"

import "./RingingCallBanner.vue?vue&type=style&index=0&id=89646660&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89646660"]])

export default __exports__